var map = {
	"./1.mp4": 9768,
	"./10.mp4": 6586,
	"./12.mp4": 2568,
	"./14.mp4": 6846,
	"./16.mp4": 4108,
	"./2.mp4": 7391,
	"./3.mp4": 2442,
	"./4.mp4": 3185,
	"./5.mp4": 220,
	"./7.mp4": 6878,
	"./8.mp4": 869,
	"./9.mp4": 8608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1700;